const controlBackgroundColor = 'rgb(255,255,255)';
const controlBorderColor = 'rgb(221,221,222)'; // same grey used by Alert.alert buttons
const buttonLabelColor = 'rgb(0,123,250)'; // same blue used by Alert.alert buttons
const maxBorderRadius = '15px';
const borderRadiusLeft = `0 0 0 ${maxBorderRadius}`;
const borderRadiusRight = `0 0 ${maxBorderRadius} 0`;
const borderRadiusOk = `0 0 ${maxBorderRadius} ${maxBorderRadius}`;
const paddingMain = '1px';
const paddingLeft = '1px 1px 0 0';
const paddingRight = '1px 0 0 0';
const ConfirmStyle = {
  controlContainer: {
    backgroundColor: controlBorderColor,
    padding: paddingMain,
    borderRadius: maxBorderRadius,
    fontFamily: 'sans-serif'
  },
  titleContainer: {
    backgroundColor: controlBackgroundColor,
    borderRadius: maxBorderRadius
  },
  titleLabel: {
    textAlign: 'center',
    padding: '16px',
    fontWeight: 'bold'
  },
  messageContainer: {
    textAlign: 'center',
    paddingBottom: '16px'
  },
  messageLabel: {
    width: '80%',
    margin: 'auto',
    textAlign: 'center'
  },
  buttonsContainer: {
    display: 'flex',
    alignContent: 'space-between',
    height: '56px'
  },
  buttonContainer: {
    backgroundColor: controlBorderColor,
    width: '50%'
  },
  buttonContainerOk: {
    borderRadius: borderRadiusOk,
    padding: paddingLeft,
    backgroundColor: controlBorderColor,
    width: '100%'
  },
  buttonContainerLeft: {
    borderRadius: borderRadiusLeft,
    padding: paddingLeft
  },
  buttonContainerRight: {
    borderRadius: borderRadiusRight,
    padding: paddingRight
  },
  buttonLabel: {
    display: 'block',
    flex: 1,
    border: 'none',
    backgroundColor: controlBackgroundColor,
    width: '100%',
    height: '100%',
    fontWeight: 'bold',
    color: buttonLabelColor
  },
  buttonLabelOk: {
    borderRadius: borderRadiusOk
  },
  buttonLabelLeft: {
    borderRadius: borderRadiusLeft,
    padding: paddingLeft
  },
  buttonLabelRight: {
    borderRadius: borderRadiusRight
  }
};
export default ConfirmStyle;
//# sourceMappingURL=ConfirmStyle.js.map